import type { AppState } from 'state/state.model';

import * as fromResults from './results/results.selectors';

export * from './infos/infos.selectors';
export * from './pendingDetails/pendingDetails.selector';

export function getQuoteStatus(state: AppState, quoteId: string) {
  return fromResults.getQuoteResult(state.quotes.results, quoteId)?.status;
}

export function getQuoteExternalId(state: AppState, quoteId: string) {
  return fromResults.getQuoteResult(state.quotes.results, quoteId)?.quoteExternalId;
}
export function getQuoteActivities(state: AppState, quoteId: string) {
  return fromResults.getQuoteResult(state.quotes.results, quoteId)?.availableActivities;
}

export function getQuoteTradeExecutionWindowInMillis(state: AppState, quoteId: string | undefined) {
  return fromResults.getQuoteResult(state.quotes.results, quoteId)?.tradeExecutionWindowInMilliseconds;
}

export function getQuoteTradeExecutionWindowStartTime(state: AppState, quoteId: string | undefined) {
  return fromResults.getQuoteResult(state.quotes.results, quoteId)?.tradeExecutionWindowStartTime;
}
